interface CropArea {
  x: number;
  y: number;
  width: number;
  height: number;
}

/**
 * Crops the given image using the specified cropped area.
 * @param imageSrc - Base64 or URL of the image to crop.
 * @param croppedArea - The area to crop from the image.
 * @returns A Promise that resolves to a cropped File object.
 */
export const cropImageFile = (
  imageSrc: string,
  croppedArea: CropArea,
  fileName = "cropped-image.jpg"
): Promise<File | null> => {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = imageSrc;

    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = croppedArea.width;
      canvas.height = croppedArea.height;

      const ctx = canvas.getContext("2d");
      if (!ctx) return resolve(null);

      ctx.drawImage(
        image,
        croppedArea.x,
        croppedArea.y,
        croppedArea.width,
        croppedArea.height,
        0,
        0,
        croppedArea.width,
        croppedArea.height
      );

      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], fileName, { type: "image/jpeg" });
          resolve(file);
        } else {
          resolve(null);
        }
      }, "image/jpeg");
    };

    image.onerror = () => {
      resolve(null);
    };
  });
};
